import './ImageUpdateLoader.css';

const ImageUpdateLoader = ({ className = '' }) => {
  return (
    <div className={`image-update-loader ${className}`}></div>
  );
};

export default ImageUpdateLoader;
